var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainimgcontainer"},[_c('img',{staticClass:"resim",class:{active:_vm.currentNumber==0},attrs:{"src":_vm.images[0]}}),_c('img',{staticClass:"resim",class:{active:_vm.currentNumber==1},attrs:{"src":_vm.images[1]}}),_c('img',{staticClass:"resim",class:{active:_vm.currentNumber==2},attrs:{"src":_vm.images[2]}})])
}
var staticRenderFns = []

export { render, staticRenderFns }